import { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { findIndex, map } from "lodash";
import { convertSecondToMin } from "../../../Js/TimeAndDate";
import MainProgressBar from "../../ProgressBar/MainProgressBar";
import CircleProgressBar from "../../ProgressBar/CircleProgressBar";
import VideoModal from "../../Modal/VideoModal";
import SmartCheckCardAdvanced from "./SmartCheckCardAdvanced";

const SmartCheckCard = (props) => {
  const [currentPhonemeVideo, setCurrentPhonemeVideo] = useState(null);
  const [videoModlFlg, setVideoModlFlg] = useState(false);
  const [transcript, setTranscript] = useState([]);

  useEffect(() => {
    if (props.unscripted && props.smartCheckResult) {
      let splitedTranscipt = props.smartCheckResult.transcript.split(" ");
      let lastLength = 0;
      let myArr = [];
      let errors = props.smartCheckResult.speakers[0]?.feedbacks?.grammar?.items
        ? props.smartCheckResult.speakers[0]?.feedbacks?.grammar?.items
        : [];

      splitedTranscipt.forEach((val, index) => {
        let obj = {
          word: val,
          start: lastLength,
          end: lastLength + val.length - 1,
        };
        let pos = findIndex(errors, (o) => {
          return obj.start >= o.start_index && obj.end <= o.end_index;
        });
        if (pos > -1) {
          obj.hasError = true;
          obj.suggestion = errors[pos]["suggestion"]
            ? errors[pos]["suggestion"]
            : "";
        } else {
          obj.hasError = false;
          obj.suggestion = "";
        }
        myArr.push(obj);
        lastLength = lastLength + val.length + 1;
      });
      setTranscript(myArr);
    }
  }, [props]);

  const openPhonemes = (phoneme) => {
    if (phoneme) {
      setVideoModlFlg(true);
      setCurrentPhonemeVideo(phoneme);
    }
  };

  const createTranscript = () => {};

  return (
    <Box>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
          border: 1,
          borderColor: "#EAECEE",
          borderRadius: 4,
          minHeight: "11vh",
          maxHeight: "auto",
          padding: 1,
          "@media (min-width: 1636px)": {
            minHeight: "8vh",
          },
        }}
      >
        {!props.unscripted &&
          props.smartCheckResult &&
          props.smartCheckResult.utterance &&
          props.smartCheckResult.utterance[0] && (
            <>
              {!props.advanced && (
                <>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      letterSpacing: "5px",
                      flexWrap: "wrap",
                      justifyContent: props.align ? props.align : "flex-start",
                    }}
                  >
                    {props.smartCheckResult.utterance[0].words.map(
                      (word, windex) => {
                        return (
                          <Box
                            key={`${windex}_words`}
                            sx={{ marginLeft: windex > 0 ? 2 : 2 }}
                          >
                            {word.phonemes.map((val, index) => {
                              return (
                                <Typography
                                  key={`${index}_phonemes`}
                                  sx={{
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    color:
                                      val.decision == "error"
                                        ? "#F95562"
                                        : val.decision == "warning"
                                        ? "#FF9A56"
                                        : "#86CC7D",
                                    flexDirection: "row",
                                    display: "inline",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.4rem",
                                    },
                                    cursor:
                                      val.decision == "error"
                                        ? "pointer"
                                        : "auto",
                                  }}
                                  onClick={() => {
                                    if (val.decision == "error") {
                                      openPhonemes(val);
                                    }
                                  }}
                                >
                                  {val.text}
                                </Typography>
                              );
                            })}
                          </Box>
                        );
                      }
                    )}
                  </Grid>
                  <Grid item xs={9}>
                    <Box sx={{ pa: 0, ma: 0 }}>
                      <MainProgressBar
                        value={
                          props.smartCheckResult?.utterance[0]?.nativeness_score
                        }
                        noanimation={props.noanimation}
                      />
                    </Box>
                  </Grid>
                </>
              )}
              {props.advanced && (
                <SmartCheckCardAdvanced
                  smartCheckResult={props.smartCheckResult}
                  whatToCheck={props.whatToCheck}
                  advancedResult={(e) => {
                    if (props.advancedResultToAsset) {
                      props.advancedResultToAsset(e);
                    }
                  }}
                ></SmartCheckCardAdvanced>
              )}
            </>
          )}
        {props.unscripted &&
          props.smartCheckResult &&
          props.smartCheckResult.speakers && (
            <>
              {/* <Grid
                item
                xs={8}
                sx={{ display: "flex", letterSpacing: "5px", flexWrap: "wrap" }}
              >
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "bold",
                    flexDirection: "row",
                    display: "inline",
                    color: "primary.main",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.6rem",
                    },
                  }}
                >
                  Recording Time :{" "}
                  {Number(
                    props.smartCheckResult.speakers[0]?.total_time
                  ).toFixed(2)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "bold",
                    flexDirection: "row",
                    color: "primary.main",
                    display: "inline",
                    mt: 1,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.6rem",
                    },
                  }}
                >
                  CEFR Level :{" "}
                  {
                    props.smartCheckResult.speakers[0]?.metrics?.general_scores
                      ?.cefr?.pronunciation_cefr
                  }
                </Typography>
              </Grid> */}
              <Grid item xs={12} mt={1} textAlign={"center"}>
                <span>Overall</span>
              </Grid>
              <Grid item xs={12} mt={1} textAlign={"center"}>
                <CircleProgressBar
                  circleVal={
                    +props.smartCheckResult.speakers[0]?.metrics?.general_scores
                      ?.elsa?.eps_score
                  }
                />
              </Grid>
              <Grid item xs={12} mt={1} textAlign={"center"} color={"#DB8829"}>
                <span>
                  CEFR:{" "}
                  {
                    props.smartCheckResult.speakers[0]?.metrics?.general_scores
                      ?.cefr?.overall_cefr
                  }
                </span>
              </Grid>
              <Grid item xs={2} mt={1} textAlign={"center"}>
                <Grid container>
                  <Grid xs={12}>
                    <span style={{ fontSize: "1vw" }}>Fluency</span>
                  </Grid>
                  <Grid xs={12}>
                    <CircleProgressBar
                      circleVal={
                        +props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.elsa?.fluency_score
                      }
                    />
                  </Grid>
                  <Grid xs={12}>
                    <span style={{ color: "#DB8829" }}>
                      CEFR:{" "}
                      {
                        props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.cefr?.fluency_cefr
                      }
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} mt={1} textAlign={"center"}>
                <Grid container>
                  <Grid xs={12}>
                    <span style={{ fontSize: "1vw" }}>Grammar</span>
                  </Grid>
                  <Grid xs={12}>
                    <CircleProgressBar
                      circleVal={
                        +props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.elsa?.grammar_score
                      }
                    />
                  </Grid>
                  <Grid xs={12}>
                    <span style={{ color: "#DB8829" }}>
                      CEFR:{" "}
                      {
                        props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.cefr?.grammar_cefr
                      }
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} mt={1} textAlign={"center"}>
                <Grid container>
                  <Grid xs={12}>
                    <span style={{ fontSize: "1vw" }}>Intonation</span>
                  </Grid>
                  <Grid xs={12}>
                    <CircleProgressBar
                      circleVal={
                        +props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.elsa?.intonation_score
                      }
                    />
                  </Grid>
                  <Grid xs={12}>
                    <span style={{ color: "#DB8829" }}>
                      CEFR:{" "}
                      {
                        props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.cefr?.intonation_cefr
                      }
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} mt={1} textAlign={"center"}>
                <Grid container>
                  <Grid xs={12}>
                    <span style={{ fontSize: "1vw" }}>Pronunciation</span>
                  </Grid>
                  <Grid xs={12}>
                    <CircleProgressBar
                      circleVal={
                        +props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.elsa?.pronunciation_score
                      }
                    />
                  </Grid>
                  <Grid xs={12}>
                    <span style={{ color: "#DB8829" }}>
                      CEFR:{" "}
                      {
                        props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.cefr?.pronunciation_cefr
                      }
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} mt={1} textAlign={"center"}>
                <Grid container>
                  <Grid xs={12}>
                    <span style={{ fontSize: "1vw" }}>Vocabulary</span>
                  </Grid>
                  <Grid xs={12}>
                    <CircleProgressBar
                      circleVal={
                        +props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.elsa?.vocabulary_score
                      }
                    />
                  </Grid>
                  <Grid xs={12}>
                    <span style={{ color: "#DB8829" }}>
                      CEFR:{" "}
                      {
                        props.smartCheckResult.speakers[0]?.metrics
                          ?.general_scores?.cefr?.vocabulary_cefr
                      }
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                mt={1}
                textAlign={"center"}
                marginTop={2}
                borderBottom={"2px solid #DB8829"}
              >
                <Box
                  fontStyle={{
                    color: "#DB8829",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Detailed Report
                </Box>
              </Grid>
              <Grid item xs={12} mt={1} textAlign={"left"} marginTop={2}>
                <Box
                  fontStyle={{
                    color: "#DB8829",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Transcript |{" "}
                  {`Duration [${convertSecondToMin(
                    props.smartCheckResult.total_time
                  )} Min]`}
                </Box>
                {props.smartCheckResult.transcript && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    {transcript.map((val, index) => {
                      return (
                        <>
                          {!val.hasError && (
                            <span style={{ margin: "0 2px" }}>{val.word}</span>
                          )}
                          {val.hasError && (
                            <>
                              <s
                                style={{ margin: "0 2px", fontWeight: "bold" }}
                              >
                                {val.word}
                              </s>
                              <b style={{ margin: "0 2px", color: "#22a014" }}>
                                {val.suggestion}
                              </b>
                            </>
                          )}
                        </>
                      );
                    })}
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} mt={1} textAlign={"left"} marginTop={2}>
                <Box
                  fontStyle={{
                    color: "#DB8829",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Grammar
                </Box>
                {props.smartCheckResult.speakers[0]?.feedbacks?.grammar
                  ?.items &&
                  props.smartCheckResult.speakers[0]?.feedbacks?.grammar?.items.map(
                    (suggest) => {
                      return (
                        <>
                          <Box>
                            <span>
                              Error :{" "}
                              <b style={{ color: "red" }}>{suggest.original}</b>{" "}
                              |
                            </span>
                            <span>
                              {" "}
                              Suggestion :{" "}
                              <b
                                style={{
                                  color:
                                    suggest.suggestion &&
                                    suggest.suggestion.trim()
                                      ? "#22a014"
                                      : "#CCC",
                                }}
                              >
                                {suggest.suggestion && suggest.suggestion.trim()
                                  ? suggest.suggestion
                                  : "Remove original"}
                              </b>
                            </span>
                          </Box>
                        </>
                      );
                    }
                  )}
              </Grid>
              <Grid item xs={12} mt={1} textAlign={"left"} marginTop={2}>
                <Box
                  fontStyle={{
                    color: "#DB8829",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Pronunciation
                </Box>
                {props.smartCheckResult.speakers[0]?.feedbacks?.pronunciation
                  ?.top_errors && (
                  <span>
                    Work on these phonemes :{" "}
                    <b>
                      {map(
                        props.smartCheckResult.speakers[0]?.feedbacks
                          ?.pronunciation?.top_errors,
                        "phoneme"
                      ).join(", ")}
                    </b>
                  </span>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  letterSpacing: "5px",
                  flexWrap: "wrap",
                  justifyContent: props.align ? props.align : "flex-start",
                }}
              >
                {props.smartCheckResult.speakers[0]?.utterances.length > 0 &&
                  props.smartCheckResult.speakers[0]?.utterances.map((u, i) => {
                    return (
                      <>
                        {u &&
                          u["result"] &&
                          u["result"].words &&
                          u["result"].words.map((word, windex) => {
                            return (
                              <Box
                                key={`${windex}_words`}
                                sx={{ marginLeft: windex > 0 ? 2 : 2 }}
                              >
                                {word.phonemes.map((val, index) => {
                                  return (
                                    <Typography
                                      key={`${index}_phonemes`}
                                      sx={{
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                        color:
                                          val.decision == "incorrect"
                                            ? "#F95562"
                                            : "#86CC7D",
                                        flexDirection: "row",
                                        display: "inline",
                                        "@media (min-width: 1636px)": {
                                          fontSize: "1.4rem",
                                        },
                                        cursor:
                                          val.decision == "incorrect"
                                            ? "pointer"
                                            : "auto",
                                      }}
                                      onClick={() => {
                                        if (val.decision == "incorrect") {
                                          openPhonemes(val);
                                        }
                                      }}
                                    >
                                      {val.text}
                                    </Typography>
                                  );
                                })}
                              </Box>
                            );
                          })}
                      </>
                    );
                  })}
              </Grid>

              <Grid item xs={12} mt={1} textAlign={"left"} marginTop={2}>
                <Box
                  fontStyle={{
                    color: "#DB8829",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Vocabulary
                </Box>
                {props.smartCheckResult.speakers[0]?.metrics?.other_metrics
                  ?.vocabulary && (
                  <>
                    <span>
                      Total Words :{" "}
                      <b>
                        {
                          props.smartCheckResult.speakers[0]?.metrics
                            ?.other_metrics?.vocabulary.total_words_count
                        }
                      </b>{" "}
                      |
                    </span>
                    <span>
                      {" "}
                      Uncommon Words :{" "}
                      <b>
                        {
                          props.smartCheckResult.speakers[0]?.metrics
                            ?.other_metrics?.vocabulary.uncommon_words_count
                        }
                      </b>{" "}
                      |
                    </span>
                    <span>
                      {" "}
                      Unique Words :{" "}
                      <b>
                        {
                          props.smartCheckResult.speakers[0]?.metrics
                            ?.other_metrics?.vocabulary.unique_words_count
                        }
                      </b>{" "}
                    </span>
                  </>
                )}
                <Box fontSize={"0.7rem"}>
                  (Your score will improve if you use more uncommon words)
                </Box>
              </Grid>
            </>
          )}
      </Grid>
      {currentPhonemeVideo && (
        <VideoModal
          visible={videoModlFlg}
          toggleModal={(flag) => {
            setVideoModlFlg(flag);
          }}
          autoplay={true}
          title={
            currentPhonemeVideo.trans
              ? `${
                  currentPhonemeVideo.trans
                } | ${currentPhonemeVideo.trans_arpabet.toUpperCase()}`
              : currentPhonemeVideo.ipa
              ? `${
                  currentPhonemeVideo.ipa
                } | ${currentPhonemeVideo.trans_arpabet.toUpperCase()}`
              : `${currentPhonemeVideo.trans_arpabet.toUpperCase()}`
          }
          src={`${currentPhonemeVideo.trans_arpabet.toUpperCase()}_SIDE_1.mp4`}
          height="100%"
          style={
            props.sx
              ? { ...props.sx, borderRadius: 10, objectFit: "contain" }
              : { borderRadius: 10, objectFit: "contain" }
          }
        />
      )}
    </Box>
  );
};

export default SmartCheckCard;
